import React, { useEffect, useState } from 'react';
import { useUser } from '../context/UserContext';
import Loader from './Loader';
import api from '../utils/api';

const Recommendations = () => {
    const { user } = useUser();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const getData = async () => {
        return;
        if (!user?._id) return;
        setLoading(true);
        const res = await api.get(`/recommendation?userId=${user._id}`);
        setLoading(false);
        if (!res.ok) throw new Error('خطا در دریافت پیشنهادها');
        const data = await res.json();
        setData(data);

        setLoading(false);
    }
    useEffect(() => {
        getData();
    }, [user]);

    if (!user?._id) return null;
    if (loading) return <Loader />;
    if (error) return <div style={{ color: 'red' }}>خطا: {error.message}</div>;
    if (!data) return null;

    return (
        <div className="recommendations">
            <h2>پیشنهادها برای شما</h2>
            <section>
                <h3>اخبار</h3>
                <ul>
                    {data.news?.map(item => (
                        <li key={item._id}>{item.title}</li>
                    ))}
                </ul>
            </section>
            <section>
                <h3>رویدادها</h3>
                <ul>
                    {data.events?.map(item => (
                        <li key={item._id}>{item.title}</li>
                    ))}
                </ul>
            </section>
            <section>
                <h3>دوره‌های بازآموزی</h3>
                <ul>
                    {data.retrainings?.map(item => (
                        <li key={item._id}>{item.title}</li>
                    ))}
                </ul>
            </section>
        </div>
    );
};

export default Recommendations;
